import React, { useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { Button } from './ui/button';

export default function ThankYou() {
  const location = useLocation();
  const navigate = useNavigate();
  const conversionTracked = useRef(false);

  useEffect(() => {
    if (!location.state?.leadSubmitted || conversionTracked.current) {
      return;
    }

    conversionTracked.current = true;

    // The Google Ads conversion action is configured in public/index.html.
    if (typeof window.gtag_report_conversion === 'function') {
      window.gtag_report_conversion();
    }

    // Add any additional conversion tracking snippets here.
    navigate(location.pathname, { replace: true, state: null });
  }, [location.pathname, location.state, navigate]);

  return (
    <main className="min-h-screen bg-[#F8F9FA] flex items-center justify-center px-4 py-12">
      <section
        className="w-full max-w-xl bg-white border border-gray-100 shadow-xl text-center px-6 py-12 sm:px-12 sm:py-16"
        aria-labelledby="thank-you-title"
      >
        <CheckCircle2
          className="w-16 h-16 text-[#9A7B4F] mx-auto mb-6"
          aria-hidden="true"
        />
        <p className="text-sm font-semibold tracking-[0.2em] uppercase text-[#9A7B4F] mb-3">
          Sai Sun City
        </p>
        <h1
          id="thank-you-title"
          className="font-serif text-3xl sm:text-4xl font-bold text-gray-900 mb-4"
        >
          Thank You!
        </h1>
        <p className="text-gray-600 leading-relaxed mb-8">
          Your enquiry has been received. Our team will contact you soon.
        </p>
        <Button asChild className="bg-[#9A7B4F] hover:bg-[#8A6B3F] text-white rounded-none px-8">
          <Link to="/">Back to Home</Link>
        </Button>
      </section>
    </main>
  );
}
